export default {"src":"/_next/static/media/Preview.54a7478e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};